import { IRegistrationInfo } from '@/entities'
import { IRegistrationInfoService } from './registrationInfo.types'
import { http } from '@/shared/https'

export class RegistrationInfoService implements IRegistrationInfoService {
    registerApplicant(data): any {
        return http.post('api/ApplicantRegistration', data);
    }
} 